const WeightUnits = {
  G: 1, 
  KG: 2,
  LB: 3,
  OZ: 4
};

export default WeightUnits;